import React from 'react';
import { Tooltip as AntTooltip } from 'antd';
import type { TooltipProps } from 'antd';
import clsx from 'clsx';

/**
 * Thin wrapper over the Antd Tooltip (per the antd wrapper standardization plan):
 * single import source through @common/components. Tooltip is a portal-rendered
 * overlay — `overlayClassName` is the antd-side hook that lands on the floating
 * panel, so the `wk-tooltip` class is merged there (matches the Popover wrapper).
 * `className` on `<Tooltip>` is forwarded through rc-tooltip to rc-trigger and
 * ends up on the *trigger child* rather than the tooltip overlay, which is
 * almost never what a caller wants.
 */
export const Tooltip = ({ overlayClassName, ...props }: TooltipProps) => (
  <AntTooltip
    {...props}
    overlayClassName={clsx('wk-tooltip', overlayClassName)}
  />
);
